"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsHeader = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const Card_1 = require("./Card");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
class DetailsHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                },
                text: {
                    fontFamily: theme.fontFamily1,
                    fontSize: (0, layout_1.isTablet)() ? 22 : 18,
                    color: theme.textColor1,
                    width: '80%',
                    textAlign: 'center'
                },
                button: {
                    height: (0, layout_1.isTablet)() ? 28 : 24,
                    width: (0, layout_1.isTablet)() ? 28 : 24,
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderColor: theme.borderColor1,
                    borderWidth: 1,
                    borderRadius: 24
                },
                buttonPlaceholder: {
                    height: (0, layout_1.isTablet)() ? 28 : 24,
                    width: (0, layout_1.isTablet)() ? 28 : 24
                }
            });
            return styles;
        };
        this.renderButton = (type, onPress) => {
            const styles = this.getStyles();
            const theme = (0, theme_1.getTheme)();
            if (onPress) {
                return (React.createElement(react_native_1.TouchableOpacity, { style: styles.button, onPress: onPress },
                    React.createElement(FontAwesome_1.default, { name: type === 'left' ? 'angle-left' : 'angle-right', color: theme.textColor3, size: 14 })));
            }
            return React.createElement(react_native_1.View, { style: styles.buttonPlaceholder });
        };
    }
    render() {
        const { text, textStyle, onLeftPress, onRightPress } = this.props;
        const styles = this.getStyles();
        return (React.createElement(Card_1.Card, null,
            React.createElement(Card_1.Card.Section, { style: styles.container },
                this.renderButton('left', onLeftPress),
                React.createElement(react_native_1.Text, { style: [styles.text, textStyle] }, text),
                this.renderButton('right', onRightPress))));
    }
}
exports.DetailsHeader = DetailsHeader;
